import { Component, inject } from '@angular/core';
import {
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-success-snackbar',
  templateUrl: 'success-snackbar.component.html',
  styles: `
    :host {
      display: flex;
    }

    .success-snackbar {
      background-color: #2ba958;
      color: #eeeeee;
    }
    .action {
      background-color: #2ba958;
      padding: 0 10px;
    }
  `,
  imports: [
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
  ],
})
export class SuccessSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
}
